import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import type { UpdateTaskConfigInput } from '@pms/shared';
import { tasksService } from '@/services/tasks.service';
import { getErrorMessage } from '@/lib/errors';

/** Shared loader + saver for the key-value task settings (reset/reminder/report tabs). */
export function useConfigSettings() {
  const qc = useQueryClient();
  const query = useQuery({
    queryKey: ['tasks', 'config', 'settings'],
    queryFn: () => tasksService.getConfigSettings(),
  });
  const mutation = useMutation({
    mutationFn: (patch: UpdateTaskConfigInput) => tasksService.updateConfigSettings(patch),
    onSuccess: () => {
      toast.success('Settings saved');
      qc.invalidateQueries({ queryKey: ['tasks', 'config', 'settings'] });
    },
    onError: (e) => toast.error(getErrorMessage(e)),
  });
  return { ...query, save: mutation.mutate, saving: mutation.isPending };
}
